angular.module('common.services').factory('edgeGroupFactoryV2', [
  '$http',
  '$filter',
  '$localStorage',
  function ($http, $filter, $localStorage) {
    this.list = []

    this.clear = function () {
      this.list = []
    }

    this.findItemById = id => {
      const [item] = $filter('filter')(
        this.list,
        ({ id: itemId }) => itemId === id
      )
      return item
        ? {
            item,
            index: this.list.indexOf(item),
            status: 1
          }
        : {
            status: 0
          }
    }

    this.addOrUpdateItem = item => {
      const { index, status } = this.findItemById(item.id)

      if (status === 1) {
        const { name } = item
        this.list[index].name = name
      } else {
        this.list.push(item, this.list.pop())
      }
    }

    this.deleteItemById = id => {
      const { index, status } = this.findItemById(id)

      if (status === 1) {
        this.list.splice(index, 1)
      }
    }

    /**
     * @name addGroup
     * @desc Add new group to organization
     * @param {Number} organizationId Organization ID
     * @param {String} groupName Name that will be set for a new device
     * @returns {Promise} Newly added group object
     */
    this.addGroup = function (organizationId, groupName) {
      return $http({
        method: 'POST',
        url: `${V2_BASEURL}/organizations/${organizationId}/groups`,
        data: {
          orgId: organizationId,
          name: groupName
        }
      })
    }

    this.getGroups = function (
      organizationId,
      sort = 'creationTime',
      order = 'desc'
    ) {
      return $http({
        method: 'GET',
        url: `${V2_BASEURL}/organizations/${organizationId}/groups?sort=${sort}&order=${order}`
      })
    }

    return this
  }
])
